import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function NotFound() {
  return (
    <section data-testid="not-found-page" className="bg-[#16302B] py-32 text-white md:py-44">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <p className="eyebrow text-[#D95D39]">404</p>
        <h1 className="mt-4 font-display text-5xl font-black leading-[0.95] tracking-tighter sm:text-6xl lg:text-7xl">
          That trail doesn't go anywhere.
        </h1>
        <p className="mt-6 max-w-xl text-base text-white/80 md:text-lg">
          The page you're looking for isn't here. Head back to base and we'll
          get you sorted.
        </p>
        <Link
          to="/"
          data-testid="notfound-home-link"
          className="mt-10 inline-flex items-center gap-2 bg-[#D95D39] px-7 py-4 text-sm font-bold uppercase tracking-wider text-white transition-colors hover:bg-[#B94B2C]"
        >
          Back to home <ArrowRight size={16} strokeWidth={2.5} />
        </Link>
      </div>
    </section>
  );
}
